import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Autocomplete, TextField, MenuItem } from "@mui/material";

import {
  EventContainer,
  FormGrid,
  Card,
  CardTitle,
  InputGroup,
  InputLabel,
  Textarea,
  TagsSection,
  Tag,
} from "./styles";

export default function DetalhesCurso({ cursoData = {}, setCursoData }) {
  const locaisOriximina = [
    "Centro",
    "Cidade Nova",
    "Juruti Velho",
    "Bairro São Sebastião",
    "Santíssimo",
    "Bela Vista",
    "Rua 7 de Setembro",
    "Rua Marechal Rondon",
    "Aldeia",
  ];

  const tagColors = {
    Educação: "#6366F1",
    Esporte: "#6366F1",
    Cultura: "#A855F7",
    Saúde: "#10B981",
    Natureza: "#10B981",
    Treinamento: "#F59E0B",
    Lazer: "#9333EA66",
    Tecnologia: "#1D4ED8",
    IA: "#7E22CE",
  };

  // Garante que contatos e conteúdos sempre existam
  const contatos = cursoData.contatos?.length
    ? cursoData.contatos
    : [{ id: Date.now() + Math.random(), telefone: "", email: "", redeSocial: "" }];

  const conteudos = cursoData.conteudos?.length
    ? cursoData.conteudos
    : [{ titulo: "", itens: [""] }];

  function toggleTag(tag) {
    const newTags = cursoData.tags?.includes(tag)
      ? cursoData.tags.filter((t) => t !== tag)
      : [...(cursoData.tags || []), tag];
    setCursoData({ ...cursoData, tags: newTags });
  }

  const handleContatoChange = (id, field, value) => {
    const novos = contatos.map((c) => (c.id === id ? { ...c, [field]: value } : c));
    setCursoData({ ...cursoData, contatos: novos });
  };

  const handleAdicionarContato = () => {
    const novo = { id: Date.now() + Math.random(), telefone: "", email: "", redeSocial: "" };
    setCursoData({ ...cursoData, contatos: [...contatos, novo] });
  };

  const handleRemoverContato = (id) => {
    const novos = contatos.filter((c) => c.id !== id);
    setCursoData({ ...cursoData, contatos: novos.length ? novos : [{ id: Date.now(), telefone: "", email: "", redeSocial: "" }] });
  };

  const updateTitulo = (index, value) => {
    const novos = [...conteudos];
    novos[index].titulo = value;
    setCursoData({ ...cursoData, conteudos: novos });
  };

  const updateItem = (cIndex, iIndex, value) => {
    const novos = [...conteudos];
    novos[cIndex].itens[iIndex] = value;
    setCursoData({ ...cursoData, conteudos: novos });
  };

  const addItem = (cIndex) => {
    const novos = [...conteudos];
    novos[cIndex].itens.push("");
    setCursoData({ ...cursoData, conteudos: novos });
  };

  const removeItem = (cIndex, iIndex) => {
    const novos = [...conteudos];
    novos[cIndex].itens.splice(iIndex, 1);
    if (novos[cIndex].itens.length === 0) novos[cIndex].itens = [""];
    setCursoData({ ...cursoData, conteudos: novos });
  };

  const addBloco = () => setCursoData({ ...cursoData, conteudos: [...conteudos, { titulo: "", itens: [""] }] });

  const removerBloco = (index) => {
    const novos = conteudos.filter((_, i) => i !== index);
    setCursoData({ ...cursoData, conteudos: novos.length ? novos : [{ titulo: "", itens: [""] }] });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <EventContainer>
        <FormGrid>
          {/* DETALHES PRINCIPAIS */}
          <Card style={{ gridColumn: "1 / 3" }}>
            <CardTitle>Detalhes do Curso</CardTitle>
            <InputGroup>
              <InputLabel>Título do Curso *</InputLabel>
              <TextField
                placeholder="Insira o título do curso"
                fullWidth
                value={cursoData.titulo || ""}
                onChange={(e) => setCursoData({ ...cursoData, titulo: e.target.value })}
              />
            </InputGroup>

            <InputGroup>
              <InputLabel>Descrição *</InputLabel>
              <Textarea
                placeholder="Descreva o curso..."
                value={cursoData.descricao || ""}
                onChange={(e) => setCursoData({ ...cursoData, descricao: e.target.value })}
              />
            </InputGroup>
            <InputGroup>
              <InputLabel>Status do Curso</InputLabel>
              <TextField
                select
                fullWidth
                value={cursoData.status || "Upcoming"}
                onChange={(e) =>
                  setCursoData({ ...cursoData, status: e.target.value })
                }
              >
                <MenuItem value="Upcoming">Próximo</MenuItem>
                <MenuItem value="Ongoing">Em andamento</MenuItem>
                <MenuItem value="Completed">Finalizado</MenuItem>
                <MenuItem value="Canceled">Cancelado</MenuItem>
              </TextField>
            </InputGroup>
                <InputGroup>
  <InputLabel>Vagas disponíveis</InputLabel>
  <TextField
    type="number"
    placeholder="Insira a quantidade de vagas"
    fullWidth
    value={cursoData.vagas || ""}
    onChange={(e) =>
      setCursoData({ ...cursoData, vagas: e.target.value ? parseInt(e.target.value) : "" })
    }
  />
</InputGroup>


            <InputGroup style={{ marginTop: "20px" }}>
              <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <input
                  type="checkbox"
                  checked={cursoData.destacado || false}
                  onChange={(e) => setCursoData({ ...cursoData, destacado: e.target.checked })}
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span>Curso destacado</span>
              </label>
            </InputGroup>

          </Card>

          {/* TAGS, DATAS, HORA, LOCAL, ORGANIZACAO */}
          <Card style={{ gridColumn: "1 / 3" }}>
            <InputGroup>
              <InputLabel>Selecione as tags do curso</InputLabel>
              <TagsSection>
                {Object.keys(tagColors).map((tag) => {
                  const isActive = cursoData.tags?.includes(tag);
                  return (
                    <Tag
                      key={tag}
                      style={{
                        backgroundColor: isActive ? tagColors[tag] : "#ebeef2",
                        color: isActive ? "#fff" : "#566474",
                      }}
                      onClick={() => toggleTag(tag)}
                    >
                      {tag}
                    </Tag>
                  );
                })}
              </TagsSection>
            </InputGroup>

            <FormGrid columns="2">
              <InputGroup>
                <InputLabel>Data de Início *</InputLabel>
                <DatePicker
                  value={cursoData.dataInicio || null}
                  onChange={(date) => setCursoData({ ...cursoData, dataInicio: date })}
                  format="DD/MM/YYYY"
                  sx={{ width: "100%" }}
                />
              </InputGroup>

              <InputGroup>
                <InputLabel>Data de Fim *</InputLabel>
                <DatePicker
                  value={cursoData.dataFim || null}
                  onChange={(date) => setCursoData({ ...cursoData, dataFim: date })}
                  format="DD/MM/YYYY"
                  sx={{ width: "100%" }}
                />
              </InputGroup>

              <InputGroup>
                <InputLabel>Hora</InputLabel>
                <TimePicker
                  value={cursoData.hora || null}
                  onChange={(time) => setCursoData({ ...cursoData, hora: time })}
                  sx={{ width: "100%" }}
                />
              </InputGroup>

              <InputGroup>
                <InputLabel>Local</InputLabel>
                <Autocomplete
                  freeSolo
                  options={locaisOriximina}
                  inputValue={cursoData.local || ""}
                  onInputChange={(e, newValue) => setCursoData({ ...cursoData, local: newValue })}
                  renderInput={(params) => <TextField {...params} placeholder="Escolha ou digite o local" />}
                />
              </InputGroup>

              <InputGroup>
                <InputLabel>Organização *</InputLabel>
                <TextField
                  placeholder="Nome da organização, pessoa ou grupo"
                  fullWidth
                  value={cursoData.organizacao || ""}
                  onChange={(e) => setCursoData({ ...cursoData, organizacao: e.target.value })}
                />
              </InputGroup>
            </FormGrid>
          </Card>

          {/* CONTATOS */}
          <Card style={{ gridColumn: "1 / 3" }}>
            <CardTitle>Contatos do Curso</CardTitle>
            {contatos.map((contato) => (
              <div key={contato.id} style={{ display: "flex", gap: "10px", marginBottom: "12px", alignItems: "flex-start" }}>
                <TextField label="Telefone" fullWidth value={contato.telefone} onChange={(e) => handleContatoChange(contato.id, "telefone", e.target.value)} />
                <TextField label="Email" fullWidth value={contato.email} onChange={(e) => handleContatoChange(contato.id, "email", e.target.value)} />
                <TextField label="Rede Social (link)" fullWidth value={contato.redeSocial} onChange={(e) => handleContatoChange(contato.id, "redeSocial", e.target.value)} />

                {contatos.length > 1 && (
                  <button
                    type="button"
                    onClick={() => handleRemoverContato(contato.id)}
                    style={{ background: "#ef4444", color: "#fff", border: "none", padding: "8px 12px", borderRadius: "8px", cursor: "pointer", height: "fit-content" }}
                  >
                    Remover
                  </button>
                )}
              </div>
            ))}

            <button
              type="button"
              onClick={handleAdicionarContato}
              style={{ marginTop: "10px", padding: "10px 14px", borderRadius: "8px", border: "none", background: "#2563eb", color: "white", cursor: "pointer", fontSize: "15px" }}
            >
              Adicionar contato
            </button>
          </Card>

          {/* CONTEÚDOS */}
          <Card style={{ gridColumn: "1 / 3" }}>
            <CardTitle>Conteúdos do Curso</CardTitle>
            {conteudos.map((conteudo, index) => (
              <div key={index} style={{ border: "1px solid #e5e7eb", borderRadius: "8px", padding: "16px", marginBottom: "20px" }}>
                <TextField label="Título do conteúdo" fullWidth value={conteudo.titulo} onChange={(e) => updateTitulo(index, e.target.value)} style={{ marginBottom: "12px" }} />

                <strong>Itens</strong>
                {conteudo.itens.map((item, iIndex) => (
                  <div key={iIndex} style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "10px" }}>
                    <TextField placeholder={`Item ${iIndex + 1}`} fullWidth value={item} onChange={(e) => updateItem(index, iIndex, e.target.value)} />
                    <button type="button" onClick={() => removeItem(index, iIndex)} style={{ background: "#dc2626", color: "#fff", border: "none", padding: "8px 12px", borderRadius: "6px", cursor: "pointer" }}>X</button>
                  </div>
                ))}

                <button type="button" onClick={() => addItem(index)} style={{ padding: "8px 12px", background: "#2563eb", borderRadius: "6px", color: "#fff", border: "none", cursor: "pointer", marginBottom: "12px" }}>+ Adicionar item</button>

                {conteudos.length > 1 && (
                  <button type="button" onClick={() => removerBloco(index)} style={{ padding: "8px 12px", background: "#dc2626", borderRadius: "6px", color: "#fff", border: "none", cursor: "pointer", marginLeft: "10px" }}>Remover bloco</button>
                )}
              </div>
            ))}

            <button type="button" onClick={addBloco} style={{ padding: "10px 14px", background: "#059669", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "15px" }}>
              + Adicionar novo conteúdo
            </button>
          </Card>
        </FormGrid>
      </EventContainer>
    </LocalizationProvider>
  );
}
